import { render, staticRenderFns } from "./SubListMain.vue?vue&type=template&id=59c027aa&scoped=true"
import script from "./SubListMain.vue?vue&type=script&lang=js"
export * from "./SubListMain.vue?vue&type=script&lang=js"
import style0 from "./SubListMain.vue?vue&type=style&index=0&id=59c027aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59c027aa",
  null
  
)

export default component.exports